export interface PurchaseNotification {
  name: string;
  location: string;
  product: string;
  timeAgo: string;
}

// Illustrative recent-activity notices used for the on-page social proof
// widget. Not sourced from real order data.
export const purchaseNotifications: PurchaseNotification[] = [
  { name: 'Marcos R.', location: 'Valencia', product: 'Maestro en Pista', timeAgo: 'hace 3 minutos' },
  { name: 'Laura G.', location: 'Sevilla', product: 'el Kit de Ejecución', timeAgo: 'hace 8 minutos' },
  { name: 'Iker A.', location: 'Bilbao', product: 'Maestro en Pista', timeAgo: 'hace 14 minutos' },
  { name: 'Cristina M.', location: 'Málaga', product: 'el Kit de Ejecución', timeAgo: 'hace 21 minutos' },
  { name: 'Javier P.', location: 'Zaragoza', product: 'Maestro en Pista', timeAgo: 'hace 27 minutos' },
  { name: 'Sara D.', location: 'Alicante', product: 'el Kit de Ejecución', timeAgo: 'hace 35 minutos' },
  { name: 'Diego T.', location: 'Murcia', product: 'Maestro en Pista', timeAgo: 'hace 42 minutos' },
  { name: 'Elena V.', location: 'Madrid', product: 'el Kit de Ejecución', timeAgo: 'hace 51 minutos' }
];
